import React from 'react'
import TxnList from '../TxnList'

const TransactionsSection = ({ transactions, backgroundColor }) => {
  if (!transactions) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        alignItems: 'flex-start',
        width: '100%',
        marginTop: '32px',
      }}
    >
      <div
        style={{
          fontFamily: 'Inter Display, sans-serif',
          fontWeight: '600',
          fontSize: '32px',
          color: 'white',
          lineHeight: '1.4',
        }}
      >
        Transactions
      </div>
      <TxnList transactions={transactions} color={backgroundColor} />
    </div>
  )
}

export default TransactionsSection
